import React from 'react';
import { ClipboardCheck, ShieldCheck, AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SEO } from '../lib/seo';

const SafetyInspections: React.FC = () => {
  const { t } = useTranslation();

  const electricalItems = [
    t('inspectionsPage.inspectionAreas.electrical.items.0'),
    t('inspectionsPage.inspectionAreas.electrical.items.1'),
    t('inspectionsPage.inspectionAreas.electrical.items.2'),
    t('inspectionsPage.inspectionAreas.electrical.items.3'),
    t('inspectionsPage.inspectionAreas.electrical.items.4')
  ];

  const safetyItems = [
    t('inspectionsPage.inspectionAreas.safety.items.0'),
    t('inspectionsPage.inspectionAreas.safety.items.1'),
    t('inspectionsPage.inspectionAreas.safety.items.2'),
    t('inspectionsPage.inspectionAreas.safety.items.3'),
    t('inspectionsPage.inspectionAreas.safety.items.4')
  ];

  return (
    <>
      <SEO 
        title="Inspecciones de Seguridad Eléctrica Barcelona | Certificación"
        description="Inspecciones de seguridad eléctrica profesionales en Barcelona. Evaluación integral, verificación de cumplimiento y prevención de riesgos."
        canonical="/safety-inspections"
        type="website"
      />
      
      <div className="py-16">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-8">{t('inspectionsPage.title')}</h1>

          <div className="grid md:grid-cols-3 gap-8 mb-12">
            <div className="bg-gray-50 p-6 rounded-lg">
              <ClipboardCheck className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('inspectionsPage.features.assessment.title')}</h3>
              <p>{t('inspectionsPage.features.assessment.description')}</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <ShieldCheck className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('inspectionsPage.features.compliance.title')}</h3>
              <p>{t('inspectionsPage.features.compliance.description')}</p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg">
              <AlertTriangle className="w-12 h-12 text-yellow-500 mb-4" />
              <h3 className="text-xl font-bold mb-2">{t('inspectionsPage.features.prevention.title')}</h3>
              <p>{t('inspectionsPage.features.prevention.description')}</p>
            </div>
          </div>

          <div className="prose max-w-none">
            <h2 className="text-3xl font-bold mb-6">{t('inspectionsPage.inspectionAreas.title')}</h2>
            
            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div>
                <h3 className="text-xl font-bold mb-4">{t('inspectionsPage.inspectionAreas.electrical.title')}</h3>
                <ul className="space-y-2">
                  {electricalItems.map((item, index) => (
                    <li key={index}>• {item}</li>
                  ))}
                </ul>
              </div>
              <div>
                <h3 className="text-xl font-bold mb-4">{t('inspectionsPage.inspectionAreas.safety.title')}</h3>
                <ul className="space-y-2">
                  {safetyItems.map((item, index) => (
                    <li key={index}>• {item}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="bg-yellow-50 p-8 rounded-lg mb-12">
              <h2 className="text-3xl font-bold mb-6">{t('inspectionsPage.process.title')}</h2>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('inspectionsPage.process.visual.title')}</h3>
                  <p>{t('inspectionsPage.process.visual.description')}</p>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('inspectionsPage.process.testing.title')}</h3>
                  <p>{t('inspectionsPage.process.testing.description')}</p>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('inspectionsPage.process.documentation.title')}</h3>
                  <p>{t('inspectionsPage.process.documentation.description')}</p>
                </div>
                <div>
                  <h3 className="text-xl font-bold mb-2">{t('inspectionsPage.process.certification.title')}</h3>
                  <p>{t('inspectionsPage.process.certification.description')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SafetyInspections;